import { Outlet } from '@tanstack/react-router';
import { BrandMark, useBranding } from './branding';

/**
 * Full-screen layout for pages outside the app shell (sign-in, waiting for approval): brand charcoal
 * with an orange glow, dark in both themes like the brand identity's dark artwork.
 */
export function BlankLayout() {
  const { name } = useBranding();
  return (
    <div className="dark relative flex min-h-dvh flex-col items-center justify-center overflow-hidden bg-charcoal px-4 py-10 text-foreground [color-scheme:dark]">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_90%_55%_at_100%_100%,color-mix(in_oklch,var(--brand),transparent_72%),transparent_70%),radial-gradient(ellipse_60%_45%_at_0%_0%,color-mix(in_oklch,var(--brand),transparent_90%),transparent_70%)]"
      />
      <div className="relative mb-6 flex items-center gap-2">
        <BrandMark size="md" />
        <span className="text-lg font-semibold">{name}</span>
      </div>
      <div className="relative w-full max-w-sm">
        <Outlet />
      </div>
    </div>
  );
}
